<template>
<div class="comment-item" v-loading="deletePostLoading">
    <div class="user-avatar"><YorkbbsImage :src="avatar" borderRadius="50%" width="30px" height="30px"></YorkbbsImage></div>
    <div class="flex-cont">
        <div class="first-blk">
            <div class="user">{{ userName }}</div>
            <div class="time">{{ comment.createdAt|timeFormat('yyyy-mm-dd') }}</div>
        </div>
        <div class="show-comment-score" v-if="comment.parentCommentId == 0">
            <ShowCommentScore :score="stars" />
        </div>
        <div class="des-cont">{{content }}</div>
        <div class="suggest-dish" v-if="suggestDish.length >0">
            推荐：
            <span v-for="(item,index) in suggestDish" :key="item.id">
                {{ item.name }}
                <template v-if="index != suggestDish.length-1">、</template>
            </span>
            
        </div>
        <ul class="img-list">
            <li v-for="(img,index) in imagesList" :key="index">
                <div class="box"><img :src="img|webpFormat(375)" alt=""></div>
            </li>
        </ul>
        <div class="control-fn">
            <el-dropdown trigger="click"  @command="handleCommand" v-if="isManager">
                <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="delete">删除评论</el-dropdown-item>  
                </el-dropdown-menu>
            </el-dropdown>
            <div class="thump" @click="thumbUpFun" v-loading="thumpPostLoading">
                <i class="yk-zan" v-if="!isThumbUp"></i>
                <i class="yk-house_good active" v-else></i>
                {{ thumbupCount||'赞' }}
            </div>
            <div class="post-active" @click="writeComment"><i class="el-icon-edit-outline"></i> 评论</div>
        </div>
        <div class="comment-info">
            <CommentItem v-for="comment in floorChildren" :key="comment.id" :comment="comment" @writeComment="writeComment" @delItem="delItem" />
        </div>
    </div>
</div>
</template>
<script>
import { webpFormat } from '@/utils/utils';
import ShowCommentScore from './show-comment-score.vue'
export default {
    name:"CommentItem",
    components:{ShowCommentScore},
    props:{ 
        comment:{
            type:Object,
            default:{},
        }
    },
    computed:{
        loginUser(){
            return this.$store.getters.user||{}
        },
        isManager(){
            if( this.loginUser.identity == 3) return true;
            if( this.loginUser.id == this.user.id ) return true;
            return false;
        },   
        user(){
            return this.comment.user;
        },
        
        avatar(){
            return this.comment.user.avatar;
        },
        userName(){
            return this.comment.user.username||'';
        },
        userId(){
            return this.comment.user.id;
        },
        imagesList(){
            return this.comment.imageList||[];
        },
        content(){
            return this.comment.content||'';
        },
        thumbupCount(){
            return this.comment.thumbupCount||0;
        },
        isThumbUp(){
            return this.comment.hasGivenThumbUp==1;
        },
        stars(){
            return this.comment.stars||0;
        },
        floorChildren(){
            return this.comment.children||[];
        },
        suggestDish(){
            return this.comment.dishList||[];
        }


    },
    data(){
        return {
            thumpPostLoading:false,
            deletePostLoading:false,
        }
    },
    methods:{
        async thumbUpFun(){
            this.thumpPostLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/give/thumbup/to/comment',{id:this.comment.id})
            this.thumpPostLoading = false;
            if(result.code == 0 ){
                this.$success('操作成功!');
                if( this.isThumbUp ==1 ){
                    /* this.isThumbUp = 0;
                    this.thumbUpCount--; */
                    this.comment.hasGivenThumbUp = 0
                    this.comment.thumbupCount --;
                }else{
                    this.comment.hasGivenThumbUp = 1
                    this.comment.thumbupCount ++;
                }
            }
        },
        writeComment(){
            this.$emit('writeComment',this.comment)
        },
        handleCommand(command){
            if( command == 'delete'){
                this.deleteCommentConfirm();
            }
        },
        deleteCommentConfirm(){
            this.$confirm('确定要删除该评论吗？','确认',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.deleteComment();
            }).catch();
        },
        async deleteComment(){
            this.deletePostLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/drop/comment',{id:this.comment.id})
            this.deletePostLoading = false;
            if( result.code == 0 ){
                this.$success('操作成功!')
                this.delItem(this.comment.id);
            }
      
            //this.delItem(this.comment.id);
        },
        delItem(id){
            this.$emit('delItem',id)
        }
    }
}
</script>
<style lang="scss" scoped>
.comment-item{
    display: flex; padding: 10px 0;
    .user-avatar{margin-right: 10px;}
    .flex-cont{flex:1; overflow: hidden;}
    .first-blk{display: flex; justify-content: space-between; align-items: center;
        .user{font-size: 14px; line-height: 20px;}
        .time{font-size: 12px; color: #666;}
    }
    .des-cont{
        font-size: 14px; line-height: 24px; margin-top: 10px;
    }
    .img-list{
        display: flex; margin: 10px -5px 0; flex-wrap: wrap;
        li{
            padding: 0 5px; width:16.66%; margin-bottom: 10px;
            .box{
                aspect-ratio: 4 / 3;
                img{
                    width:100%; height: 100%; object-fit: cover;
                }
            }
        }
    }
    .show-comment-score{margin-top: 10px;}
    .el-dropdown-link{cursor: pointer; font-size: 16px; color: #909090;}
    .control-fn{
        display: flex; justify-content: flex-end; align-items: center;
        .thump,.post-active{
            margin: 0 0 0 20px; cursor: pointer;
            display: flex; align-items: center;
            font-size: 14px; color: #1b1b1b;
            i{margin-right: 5px;}
            .active{color: #e43a3a;}
        }
        
    }
    .suggest-dish{
        font-size: 14px; color: #777; margin-top: 10px;
    }
}
</style>